import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { DataSource } from '.';

export enum ReportFrequency {
    NONE = 'none',
    MONTHLY = 'monthly'
}

export class SubAccountDatasource extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'SubAccountDatasource' })
    MODELNAME: string;

    @JsonProperty({ type: 'Date' })
    created_at: Date;

    @JsonProperty({ type: 'string' })
    page_id: string;

    @JsonProperty({ type: 'DataSource', clazz: DataSource })
    datasource: DataSource
}

export class SubAccount extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'SubAccount' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'string?' })
    logo_url?: string;

    @JsonProperty({ type: 'string' })
    report_frequency: ReportFrequency;

    @JsonProperty({ type: 'SubAccountDatasource', clazz: SubAccountDatasource })
    datasources: SubAccountDatasource[]

    @JsonProperty({ type: 'Date' })
    created_at: Date;

    @JsonProperty({ type: 'any' })
    view_structure: any;
}



// WEBPACK FOOTER //
// ./src/api/models/sub_account.ts